export default "__VITE_ASSET__60681861__"